/**
 * PREVIEW COMPANY ENTRY POINT
 *
 * The preview company page shows the available articles for a non active entity
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isEqual } from 'lodash';

import { hashHistory } from 'react-router';

import utils from './../../../utils/utilities';

import PreviewTable from './../../PreviewCompany/template/PreviewCompany.previewTable.jsx';
import PreviewEntityPanel from './Panel/PreviewEntityPanel.jsx';
import { PESTLEContentCell } from './../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';

import withStore from './../../../reusable/Wrappers/StoreWrapper/StoreWrapper.jsx';

import {
    DateContentCell,
    TitleCellNoLink,
    LanguageCell
} from './../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';

import {POST} from './../../../constants';

let actions = null;

class PreviewEntity extends React.Component {

    constructor(props) {
        super(props);

        // Determine default URL params
        let urlParams = {
            language:         'all',
            riskAngle:        'all',
            riskLevel:        'all',
            sortBy:           'date',
            direction:        'DESC',
            refreshToggle:    0,
            companyTO:        this.props.previewTableRequestPayload
        };

        if (this.props.store.preferences) {

            if (this.props.store.preferences.articlesLanguageFilter) {
                urlParams.language = this.props.store.preferences.articlesLanguageFilter;
            }

            if (this.props.store.preferences.previewCompany) {
                urlParams.riskAngle     = this.props.store.preferences.previewCompany.riskAngle;
                urlParams.riskLevel     = this.props.store.preferences.previewCompany.riskLevel;
                urlParams.sortBy        = this.props.store.preferences.previewCompany.sortBy;
                urlParams.direction     = this.props.store.preferences.previewCompany.direction;
                urlParams.refreshToggle = 0;
            }
        }

        // Initialize state
        this.state = {
            currentCompany:       null,
            columnWidths:         [31, 21, 14, 34],
            urlParams:            urlParams,
            articleCount:         null,
            filterCount:          null,
            previewEntitiesCount: 1
        };

        actions = this.props.actions;

        this.table = null;
        this.tableId = 'preview-companies-table';
        this.categoryOptions = [];
        this.rowsModel = [];
        this.panelTopPosition = 0;
        this.dialogTopPosition = 0;

        this.changeTableUrlParams = this.changeTableUrlParams.bind(this);
        this.sortByDate = this.sortByDate.bind(this);
        this.toggleEditCompanyPanel = this.toggleEditCompanyPanel.bind(this);
        this.resetEditCompanyPanel = this.resetEditCompanyPanel.bind(this);
        this.finishedAddingEntries = this.finishedAddingEntries.bind(this);
        this.sortByRiskAngle = this.sortByRiskAngle.bind(this);
        this.sortByRiskLevel = this.sortByRiskLevel.bind(this);
        this.filterByLanguage = this.filterByLanguage.bind(this);
        this.refreshCompanyData = this.refreshCompanyData.bind(this);
        this.showRefreshDialog = this.showRefreshDialog.bind(this);
        this.hideRefreshDialog = this.hideRefreshDialog.bind(this);
        this.resetRefreshDialog = this.resetRefreshDialog.bind(this);
        this.toggleEditCompanyPanelFixed = this.toggleEditCompanyPanelFixed.bind(this);
        this.toggleDialogPopupFixed = this.toggleDialogPopupFixed.bind(this);
        this.calculatePanelPosition = this.calculatePanelPosition.bind(this);
        this.calculateDialogPosition = this.calculateDialogPosition.bind(this);
        this.resetAddButtons = this.resetAddButtons.bind(this);
        this.buildArticleLink = this.buildArticleLink.bind(this);
    }

    componentWillMount() {

        this.rowsModel = [
            {
                fieldId:   'articleId',
                fieldType: TitleCellNoLink,
                props:     {
                    clickHandler: this.buildArticleLink
                }
            },
            {
                fieldId:   'language',
                fieldType: LanguageCell
            },
            {
                fieldId:   'harvestDate',
                fieldType: DateContentCell,
                classes:   'notranslate'
            },
            {
                fieldId:   'pestleCategories',
                fieldType: PESTLEContentCell,
                format:    (value) => utils.parsePestleResponse(value)
            }
        ];

        window.addEventListener('scroll', this.toggleEditCompanyPanelFixed);
        window.addEventListener('resize', this.toggleEditCompanyPanelFixed);

        window.addEventListener('scroll', this.toggleDialogPopupFixed);
        window.addEventListener('resize', this.toggleDialogPopupFixed);
        // Scrolls top to prevent the issue of the scrollbar remaining at the same position from the previous page
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleEditCompanyPanelFixed);
        window.removeEventListener('resize', this.toggleEditCompanyPanelFixed);

        window.removeEventListener('scroll', this.toggleDialogPopupFixed);
        window.removeEventListener('resize', this.toggleDialogPopupFixed);
    }

    componentWillReceiveProps(nextProps) {

        // Recalculate the edit panel position in case the user closes or opens the About section
        if (nextProps.togglePanelPositionUpdate !== this.props.togglePanelPositionUpdate) {
            this.calculatePanelPosition(true);
            this.calculateDialogPosition(true);
        }

        if (nextProps.showDialogToggle !== this.props.showDialogToggle) {
            if (nextProps.showDialogToggle) {
                this.showRefreshDialog();
            }
        }

        // Update the request payload for the Article Page in case it has changed
        if (!isEqual(nextProps.previewArticleRequestPayload, this.props.previewArticleRequestPayload)) {
            if (nextProps.showDialogToggle) {
                this.showRefreshDialog();
            }
            // let newParams = Object.assign({}, this.state.urlParams);
            // newParams.companyTO = nextProps.previewArticleRequestPayload;
            // this.setState({urlParams: newParams});
        }
    }

    componentDidMount() {
        if (this.props.isPanelAlwaysVisible) {
            this.toggleEditCompanyPanel();
        }
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        refreshDialog.classList.remove("shown");
    }

    setCounts(totalCount, filterCount) {
        this.setState({
            articleCount: totalCount,
            filterCount: filterCount
        });
    }

    buildArticleLink(event, articleId, articleIndex, rowData) {
        let companyData = this.props.companyData;
        let location    = window.location.href.substr(window.location.href.indexOf('#/') + 2);

        let config = {};
        config.headerKey = "createNewEntity";
        config.injectEntity = this.props.companyData.id;
        config.ttl = companyData.companyTitle;
        config.backRoute = location;

        config.verb = POST;
        config.url = '/api/entities/preview/';
        config.urlParams = this.state.urlParams;
        config.hideTitle = false;
        config.articleCount=this.state.filterCount;
        config.embeddedResultList="articleList";

        hashHistory.push('/view-article/' + articleId + '/' + articleIndex + '?config=' + encodeURIComponent(JSON.stringify(config)));
    }

    changeTableUrlParams(newUrlParams) {
        let urlParams = Object.assign({}, this.state.urlParams, newUrlParams);
        this.setState({urlParams: urlParams});
        actions.persistPreferences(urlParams);
        window.scrollTo(0, 0);
    }

    sortByDate() {

        this.changeTableUrlParams({
            sortBy:    'date',
            direction: this.state.urlParams.direction === 'asc' && this.state.urlParams.sortBy === 'date'
                           ? 'desc' : 'asc'
        });
    }

    sortByRiskAngle(event) {

        let riskAngle = event.target.value;

        if (!this.props.initializeEmptyTable) {
            this.setCounts(null, null);
        }

        this.changeTableUrlParams({riskAngle: riskAngle});
    }

    sortByRiskLevel(event) {

        let riskLevel = event.target.value;

        if (!this.props.initializeEmptyTable) {
            this.setCounts(null, null);
        }

        this.changeTableUrlParams({riskLevel: riskLevel});
    }

    filterByLanguage(event) {
        let language = event.target.value;

        if (!this.props.initializeEmptyTable) {
            this.setCounts(null, null);
        }

        this.changeTableUrlParams({language: language});
    }

    finishedAddingEntries(response) {

        let count = response.body && typeof response.body.totalCount === 'number' ? response.body.totalCount : 'N/A';
        let filterCount = response.body && typeof response.body.filterCount === 'number' ? response.body.filterCount :
            'N/A';

        this.setCounts(count, filterCount);
    }

    calculatePanelPosition(forceUpdate = false) {
        let panel = document.getElementsByClassName('preview-company__panel')[0];

        if (panel && (!this.panelTopPosition || forceUpdate)) {
            this.panelTopPosition = window.pageYOffset + panel.getBoundingClientRect().top;
        }
    }

    calculateDialogPosition(forceUpdate = false) {
        let dialog = document.getElementsByClassName('refresh-dialog')[0];

        if (dialog && (!this.dialogTopPosition || forceUpdate)) {
            this.dialogTopPosition = window.pageYOffset + dialog.getBoundingClientRect().top;
        }
    }

    toggleEditCompanyPanel() {

        let panel       = document.getElementsByClassName("preview-company__panel")[0],
            table       = document.getElementsByClassName("infinite-scroll-table")[0],
            tableHeader = document.getElementsByClassName("custom-table-head")[0],
            dialog      = document.getElementsByClassName("refresh-dialog")[0];

        if (panel.classList.contains('fixed')) {
            //collapse on panel will decrease width to 0
            panel.classList.add('collapse');
        }

        /* We cannot have an element ANIMATED WITH CSS3 and FIXED POSITIONED at the same
         * time do to a bug that is common across all browsers. Even the children of the
         * CSS3 animated element cannot be fixed! See the comment below.
         */
        if (!this.props.isPanelAlwaysVisible &&
            !tableHeader.classList.contains('fixed') &&
            !panel.classList.contains('fixed')) {

            panel.classList.add('animated');
            dialog.classList.add('animated');
            table.classList.add('animated');

        }

        /* Fixes an odd issue with browsers not supporting fixed elements inside parents that have CSS3 animations.
         * This bug seems to be present in all browsers.
         *
         * Please read: https://bugs.chromium.org/p/chromium/issues/detail?id=20574
         */
        setTimeout(function() {
            table.classList.remove('animated');
           // dialog.classList.add('animated');
        }, 300);

        panel.classList.toggle('slide-in');
        table.classList.toggle('collapse');
        dialog.classList.toggle('collapse');

        if (panel.classList.contains('slide-in')) {
            this.calculatePanelPosition();
        }

        if (dialog.classList.contains('collapse')) {
            this.calculateDialogPosition();
        }

        if (tableHeader.classList.contains('fixed')) {
            tableHeader.style.width = table.offsetWidth + 'px';
        }

        if (table.classList.contains('collapse')) {
            this.setState({columnWidths: [31, 21, 14, 34]});
        } else {
            this.setState({columnWidths: [46, 11, 17, 26]});
        }
    }

    toggleDialogPopupFixed() {
        // Prevent this handler from being triggered when the Search parameters section is closed on Edit Entity page,
        // or if the table is shorter than the min-height on the table
        if (document.getElementById('preview-companies-table').getBoundingClientRect().height < 400) {
            return;
        } else if (this.props.isPanelAlwaysVisible && !this.props.isSearchSectionOpened) {
            return;
        }

        let dialog          = document.getElementsByClassName('refresh-dialog')[0],
            dialog_pop      = document.getElementsByClassName('refresh-dialog__popup')[0],
            scrolledFromTop = window.scrollY || window.pageYOffset;


        if (dialog.classList.contains('collapse') && dialog.classList.contains('shown')) {
            this.calculateDialogPosition(true);
        }

        // If the refresh dialog component is opened, calculate the top offset for the fixed refresh dialog component and set it to be fixed
        if (dialog.classList.contains('shown') && dialog.classList.contains('collapse')) {

            if (dialog.classList.contains('shown') && dialog.classList.contains('collapse') && scrolledFromTop > this.dialogTopPosition) {
                dialog_pop.classList.add('fixed');
            }

            if (dialog_pop.classList.contains('fixed') && scrolledFromTop < this.dialogTopPosition) {
                dialog_pop.classList.remove('fixed');
            }
        }

    }

    toggleEditCompanyPanelFixed() {

        // Prevent this handler from being triggered when the Search parameters section is closed on Edit Entity page
        if (this.props.isPanelAlwaysVisible && !this.props.isSearchSectionOpened) {
            return;
        }

        let panel           = document.getElementsByClassName('preview-company__panel')[0],
            scrolledFromTop = window.scrollY || window.pageYOffset;

        // If the normal panel is opened, calculate the left offset for the fixed panel and set it to be fixed
        if (panel.classList.contains('slide-in')) {

            if (!panel.classList.contains('fixed') && scrolledFromTop > this.panelTopPosition) {
                panel.classList.remove('animated');
                panel.classList.add('fixed');
            }

            if (panel.classList.contains('fixed') && scrolledFromTop < this.panelTopPosition) {
                panel.classList.remove('fixed');
                panel.setAttribute('style', '');
            }
        }

        //if the panel is fixed, then closed, reset panel styles
        if (panel.classList.contains('fixed') && panel.getBoundingClientRect().width <= 2) {
            panel.className = "preview-company__panel";
            panel.setAttribute('style', '');
        }

    }

    resetEditCompanyPanel(withInputsReset = true, staysShown = false) {
        let panel = document.getElementsByClassName('preview-company__panel')[0];
        let table = document.getElementsByClassName('infinite-scroll-table')[0];
        let dialog = document.getElementsByClassName('refresh-dialog')[0];

        if (withInputsReset) {
            panel.reset();
        }

        if (staysShown) {
            panel.classList.remove('fixed');
        } else {
            panel.className = 'preview-company__panel';
            table.className = 'infinite-scroll-table';
        }

        dialog.className = 'refresh-dialog';
    }

    refreshCompanyData() {

        //resets countBox data (to show spinner) until new data comes in
        this.setCounts(null, null);

        if (this.props.isPanelAlwaysVisible) {
            this.resetEditCompanyPanel(false, true);
        }

        if (this.props.onRefreshTableHandler) {
            this.props.onRefreshTableHandler();
        }

        // Refresh table data
        this.changeTableUrlParams({
            refreshToggle: this.state.urlParams.refreshToggle === 0 ? 1 : 0
        });

        this.hideRefreshDialog();
    }

    showRefreshDialog() {
        let refreshDialog  = document.getElementsByClassName("refresh-dialog")[0],
            table          = document.getElementsByClassName("infinite-scroll-table")[0],
            collapsedClass = table.classList.contains('collapse') ? ' collapse' : '';

        refreshDialog.className = "refresh-dialog shown" + collapsedClass;
    }

    hideRefreshDialog() {
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        refreshDialog.classList.remove("shown");

        let newTO = Object.assign({}, this.state.urlParams);
        newTO.companyTO = this.props.previewArticleRequestPayload;
        this.setState({urlParams: newTO});
        // let newTO = Object.assign({}, this.props.previewArticleRequestPayload);
        // newTO.companyTO = this.props.previewArticleRequestPayload;
        // this.setState({urlParams: newTO});
    }

    resetRefreshDialog() {
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        refreshDialog.className = "refresh-dialog";
    }

    resetAddButtons() {
        let addButtons = document.getElementsByClassName('js-add-label-button');
        for (let i = 0; i < addButtons.length; i++) {
            !addButtons[i].classList.contains('button-inactive') ? addButtons[i].classList.add('button-inactive') :
                null;
        }
    }

    render() {
        return (
            <div className="preview-company-page">

                <div className="preview-company__panel-table">
                    <div className="preview-company__panel-container">

                        <PreviewEntityPanel actions={actions}
                                            showRefreshDialog={this.showRefreshDialog}
                                            companyData={this.props.companyData}
                                            updateCompanyData={this.props.updateCompanyData}
                                            toggleEditCompanyPanel={
                                                this.props.isPanelAlwaysVisible ? null : this.toggleEditCompanyPanel
                                            }>
                            {this.props.panelCustomContent}
                        </PreviewEntityPanel>
                    </div>
                    <div className="preview-company__table">

                        <div className="refresh-dialog">

                            <div className="refresh-dialog__popup">
                                <div className="refresh-dialog__popup--header">
                                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.changesSaved" />
                                </div>
                                <div className="refresh-dialog__popup--edited-search">
                                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.editedSearchTerms" />
                                </div>
                                <div className="refresh-dialog__popup--click-refresh">
                                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.clickRefresh" />
                                </div>
                                <div className="refresh-dialog__popup--button">
                                    <button className="button-primary-lg refresh"
                                            onClick={this.refreshCompanyData}>
                                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.refresh" />
                                    </button>
                                </div>
                            </div>

                        </div>


                        <PreviewTable ref="previewCompanyTable"
                                      tableId={this.tableId}
                                      columnWidths={this.state.columnWidths}
                                      rowsModel={this.rowsModel}
                                      categoryOptions={this.categoryOptions}
                                      userActions={
                                          {
                                              sortByDate:                 this.sortByDate,
                                              sortByRiskAngle:            this.sortByRiskAngle,
                                              sortByRiskLevel:            this.sortByRiskLevel,
                                              filterByLanguage:           this.filterByLanguage
                                          }
                                      }
                                      url={this.props.tableBaseUrl}
                                      tableRequestPayload={this.state.urlParams}
                                      urlParams={{}}
                                      verb={POST}
                                      initializeEmptyTable={this.props.initializeEmptyTable}
                                      preventScrollToTop={true}
                                      lifecycleEvents={
                                          {
                                              finishedAddingEntries: this.finishedAddingEntries
                                          }
                                      }
                                      count={this.state.articleCount}
                                      filterCount={this.state.filterCount} />
                    </div>
                </div>

            </div>
        );

    }

}

export default withStore(PreviewEntity, ['user.preferences']);


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/EditEntitySearchParameters/PreviewEntity.jsx